import { Component, HostListener, input, output, model, effect, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ButtonComponent } from 'src/app/@core/components/ui/button/button.component';
import { DialogComponent } from 'src/app/@core/components/ui/dialog/dialog.component';
import { InputComponent } from 'src/app/@core/components/ui/input/input.component';

@Component({
    selector: 'app-edit-thread',
    standalone: true,
    imports: [CommonModule, FormsModule, DialogComponent, ButtonComponent, InputComponent],
    templateUrl: './edit-thread.component.html',
    styleUrl: './edit-thread.component.scss'
})
export class EditThreadComponent {
    visible = model<boolean>(false);
    threadTitle = model<string>('');
    threadTitleToEdit = signal<string>('');
    isMobile = signal<boolean>(window.innerWidth < 768);

    @HostListener('window:resize')
    onResize(): void {
        this.isMobile.set(window.innerWidth < 768);
    }

    constructor() {
        effect(() => {
            this.threadTitleToEdit.set(this.threadTitle());
        });
    }

    get isSaveDisabled(): boolean {
        return this.threadTitle() === this.threadTitleToEdit();
    }

    onSave = output<void>();

    handleHide(): void {
        this.visible.set(false);
    }

    handleSave(): void {
        this.threadTitle.set(this.threadTitleToEdit());
        this.onSave.emit();
    }
}
